(function () {
  console.log('scrollOverlap in js');
  if (typeof console !== 'undefined' && console.debug) {
    console.debug('[scrollOverlap] script loaded');
  }

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  var targets = [];
  var isInitialized = false;
  var lastWindowHeight = window.innerHeight || 0;
  var bodyResizeObserver = null;
  var stickyResizeTimer = null;
  var mobileQuery = window.matchMedia('(max-width: 768px)');

  function getTargets() {
    return Array.prototype.slice.call(document.querySelectorAll('.js-scroll-overlap'));
  }

  function resetStickyOffset() {
    if (!targets.length) {
      return;
    }

    targets.forEach(function (target) {
      target.style.position = '';
      target.style.top = '';
      target.style.zIndex = '';
      target.style.removeProperty('--sticky-offset');
      target.classList.remove('is-disabled');
      delete target.dataset.scrollOverlapProcessed;
    });
  }

  function setStickyOffset() {
    if (!targets.length) {
      return;
    }

    var winHeight = lastWindowHeight;

    targets.forEach(function (target, index) {
      if (target.dataset.scrollOverlapProcessed === 'true') {
        return;
      }

      var targetHeight = target.offsetHeight;
      if (!targetHeight) {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('[scrollOverlap] target has no height', target);
        }
        return;
      }

      // 次の兄弟要素が.js-scroll-overlapを持たない場合、stickyを解除
      var nextSibling = target.nextElementSibling;
      var isLastOverlapSection = nextSibling && !nextSibling.classList.contains('js-scroll-overlap');

      if (isLastOverlapSection) {
        target.style.position = 'relative';
        target.style.top = 'auto';
        target.style.zIndex = String(index + 1);
        if (typeof console !== 'undefined' && console.debug) {
          console.debug('[scrollOverlap] last overlap section detected, setting position to relative', target);
        }
        return;
      }

      target.style.position = 'sticky';
      target.style.zIndex = String(index + 1);

      if (typeof console !== 'undefined' && console.debug) {
        try {
          var computed = window.getComputedStyle(target);
          var parent = target.parentElement;
          var parentOverflowY = parent ? window.getComputedStyle(parent).overflowY : 'n/a';
          console.debug('[scrollOverlap] target info', {
            index: index,
            height: targetHeight,
            position: computed.position,
            parentOverflowY: parentOverflowY
          });
        } catch (e) {
          console.debug('[scrollOverlap] getComputedStyle error', e);
        }
      }

      var offsetValue;
      if (winHeight > targetHeight) {
        offsetValue = '-1px';
      } else {
        var diff = targetHeight - winHeight;
        offsetValue = '-' + diff + 'px';
      }

      target.style.top = offsetValue;
      target.style.setProperty('--sticky-offset', offsetValue);
    });
  }

  function handleWindowResize() {
    var winHeight = window.innerHeight || 0;
    if (winHeight !== lastWindowHeight) {
      lastWindowHeight = winHeight;
      if (!mobileQuery.matches) {
        setStickyOffset();
      }
    }
  }

  function debounceSetStickyOffset() {
    if (stickyResizeTimer) {
      window.clearTimeout(stickyResizeTimer);
    }
    stickyResizeTimer = window.setTimeout(function () {
      if (!mobileQuery.matches) {
        setStickyOffset();
      }
    }, 100);
  }

  function toggleDisabledClass(state) {
    if (!targets.length) {
      return;
    }
    targets.forEach(function (target) {
      target.classList.toggle('is-disabled', state);
    });
  }

  var isKeyboardFocus = false;

  function handleKeydown(event) {
    if (event.key === 'Tab') {
      isKeyboardFocus = true;
      toggleDisabledClass(true);
    }
  }

  function handlePointerDown() {
    if (isKeyboardFocus) {
      isKeyboardFocus = false;
      toggleDisabledClass(false);
    }
  }

  function observeBodyChanges() {
    if (typeof ResizeObserver === 'undefined') {
      return;
    }

    if (bodyResizeObserver) {
      bodyResizeObserver.disconnect();
    }

    bodyResizeObserver = new ResizeObserver(function () {
      debounceSetStickyOffset();
    });
    bodyResizeObserver.observe(document.body);
  }

  function cleanupTargets() {
    if (!targets.length && bodyResizeObserver) {
      bodyResizeObserver.disconnect();
      bodyResizeObserver = null;
    }
  }

  function disableOverlapForMobile() {
    resetStickyOffset();
    toggleDisabledClass(false);
    if (document && document.body) {
      document.body.classList.remove('scroll-overlap-active');
    }
  }

  function scrollOverlap() {
    if (typeof console !== 'undefined' && console.debug) {
      console.debug('[scrollOverlap] initialize start');
    }

    targets = getTargets();
    if (!targets.length) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[scrollOverlap] no targets found');
      }
      cleanupTargets();
      return;
    }

    if (mobileQuery.matches) {
      if (typeof console !== 'undefined' && console.debug) {
        console.debug('[scrollOverlap] mobile viewport detected, disabling overlap');
      }
      disableOverlapForMobile();
      cleanupTargets();
      return;
    }

    lastWindowHeight = window.innerHeight || 0;
    if (typeof console !== 'undefined' && console.debug) {
      console.debug('[scrollOverlap] targets detected:', targets.length);
      console.debug('[scrollOverlap] window height:', lastWindowHeight);
    }

    if (targets.length && document && document.body) {
      document.body.classList.add('scroll-overlap-active');
    }

    setStickyOffset();
    observeBodyChanges();

    if (!isInitialized) {
      window.addEventListener('resize', handleWindowResize, { passive: true });
      document.addEventListener('keydown', handleKeydown, false);
      document.addEventListener('mousedown', handlePointerDown, false);
      document.addEventListener('touchstart', handlePointerDown, { passive: true });
      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', scrollOverlap);
      } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(scrollOverlap);
      }
      isInitialized = true;
      if (typeof console !== 'undefined' && console.debug) {
        console.debug('[scrollOverlap] global listeners registered');
      }
    }

    if (typeof console !== 'undefined' && console.debug) {
      console.debug('[scrollOverlap] initialize complete');
    }
  }

  window.scrollOverlap = scrollOverlap;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof console !== 'undefined' && console.debug) {
        console.debug('[scrollOverlap] DOMContentLoaded fired');
      }
      scrollOverlap();
    });
  } else {
    if (typeof console !== 'undefined' && console.debug) {
      console.debug('[scrollOverlap] document already ready');
    }
    scrollOverlap();
  }
  console.log('scrollOverlap in js end');
})();

